import CompactExpenseTypeToken from '@apps/finance/admin/tokens/expense_type/compact'
import CompactProjectToken from '@apps/finance/admin/tokens/project/compact'
import CompactTypeToken from '@apps/finance/admin/tokens/type/compact'
import ExpenseTypeToken from '@apps/finance/admin/tokens/expense_type'
import ProjectToken from '@apps/finance/admin/tokens/project'
import VendorToken from '@apps/finance/admin/tokens/vendor'
import TypeToken from '@apps/finance/admin/tokens/type'
import ReimbursementNew from '../reimbursements/new'
import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'
import ExpenseNew from '../expenses/new'
import AdvanceNew from '../advances/new'
import TripImport from '../trips/import'
import ItemTask from '../items/task'
import CheckNew from '../checks/new'
import TripNew from '../trips/new'
import batchTask from '../batch'

const mapPropsToPanel = (props, context) => ({
  title: 't(Items)',
  access: { rights: { $oneOf: ['finance:manage_expenses'] } },
  collection: {
    endpoint: '/api/admin/finance/items',
    table: [
      { label: 't(ID)', key: 'item_id', collapsing: true, visible: false },
      { label: 't(Type)', key: 'type', collapsing: true, format: CompactTypeToken },
      { label: 't(Date)', key: 'date', collapsing: true, format: 'date' },
      { label: 'Project', key: 'project.title', sort: 'finance_projects.title', format: CompactProjectToken },
      { label: 't(Description)', key: 'description', primary: true },
      { label: 'Expense Type', key: 'expense_type.title', sort: 'finance_expense_types.title', format: CompactExpenseTypeToken },
      { label: 'Vendor', key: 'vendor.name', sort: 'finance_vendors.name' },
      { label: 'Account', key: 'account.name', sort: 'finance_accounts.name' },
      { label: 't(Amount)', key: 'amount', collapsing: true, primary: true, format: 'currency' },
      { label: 't(Status)', key: 'status', collapsing: true, align: 'center', format: StatusToken }
    ],
    criteria: {
      fields: [
        { label: 'item', fields: [
          { name: 'Type', key: 'type', type: 'select', options: [
            { value: 'expense', text: 't(Expense)' },
            { value: 'reimbursement', text: 't(Reimbursement)' },
            { value: 'check', text: 't(Check Request)' },
            { value: 'trip', text: 't(Mileage)' },
            { value: 'advance', text: 't(Cash Advance)' }
          ], format: TypeToken, search: false },
          { name: 'Project', key: 'project_id', type: 'select', endpoint: '/api/admin/finance/projects', valueKey: 'id', textKey: 'title', format: ProjectToken },
          { name: 'Expense Type', key: 'expense_type_id', type: 'select', multiple: true, endpoint: '/api/admin/finance/expense_types', valueKey: 'id', textKey: 'title', format: ExpenseTypeToken },
          { name: 'Vendor', key: 'vendor_id', type: 'select', endpoint: '/api/admin/finance/vendors', valueKey: 'id', textKey: 'name', format: VendorToken },
          { name: 'Account', key: 'account_id', type: 'select', endpoint: '/api/admin/finance/accounts', valueKey: 'id', textKey: 'name' },
          { name: 'Date Range', key: 'date', type: 'daterange', include: ['this','last'] },
          { name: 'Status', key: 'status', type: 'select', options: ['incomplete','pending','submitted','approved','rejected','reviewed','exported'], format: StatusToken }
        ] }
      ]
    },
    export: [
      { label: 't(ID)', key: 'id' },
      { label: 't(Type)', key: 'type' },
      { label: 't(Date)', key: 'date' },
      { label: 't(User)', key: 'user.full_name' },
      { label: 'Project Code', key: 'project.integration.project_code' },
      { label: 'Project', key: 'project.title' },
      { label: 'Expense Type Code', key: 'expense_type.integration.expense_code' },
      { label: 'Expense Type', key: 'expense_type.title' },
      { label: 'Vendor', key: 'vendor.name' },
      { label: 'Account', key: 'account.name' },
      { label: 't(Description)', key: 'description' },
      { label: 'Time Leaving', key: 'time_leaving' },
      { label: 'Time Arriving', key: 'time_arriving' },
      { label: 'Odometer Start', key: 'odometer_start' },
      { label: 'Odometer End', key: 'odometer_end' },
      { label: 'Total Miles', key: 'total_miles' },
      { label: 't(Amount)', key: 'amount' },
      { label: 't(Status)', key: 'status' }
    ],
    defaultSort: { key: 'date', order: 'desc' },
    empty: {
      svg: 'dollar_sign',
      title: 't(No Items)',
      text: 't(You have not yet created any items)'
    },
    selectable: true,
    selectValue: 'code',
    entity: 'items',
    buttons: (selected, onSuccess) => [
      batchTask(context, selected, onSuccess, 'blue', 'submit', 'submitted', 'pending', '/api/admin/finance/items/submit_all')
    ],
    onClick: (record) => context.router.push(`/finance/${record.type}s/${record.item_id}`)
  },
  tasks: {
    svg: 'plus',
    items: [
      { component: ItemTask('expense', 'Expense', 'I made a purchase with a work credit card or store account'), modal: ExpenseNew },
      { component: ItemTask('reimbursement', 'Reimbursement', 'I made a purchase with my own money'), modal: ReimbursementNew },
      { component: ItemTask('check', 'Check Request', 'I need a check sent to a vendor'), modal: CheckNew },
      { component: ItemTask('trip', 'Mileage', 'I need to be reimbursed for mileage'), modal: TripNew },
      { component: ItemTask('import', 'Bulk Mileage Import', 'I need to be reimbursed for many trips'), modal: TripImport },
      { component: ItemTask('advance', 'Cash Advance', 'I need a check or cash in advance'), modal: AdvanceNew }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
